import * as basicLightbox from 'basiclightbox';
import { $mount } from '../../../js/dom-lifecycle';

$mount('.ea-lightbox-thumbnail').on('click', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const content = document.querySelector(this.getAttribute('data-ea-lightbox-content-selector')).innerHTML;
    basicLightbox.create(content).show();
});
